import { render, staticRenderFns } from "./FirstTranDia.vue?vue&type=template&id=1db5f501&scoped=true"
import script from "./FirstTranDia.vue?vue&type=script&lang=js"
export * from "./FirstTranDia.vue?vue&type=script&lang=js"
import style0 from "./FirstTranDia.vue?vue&type=style&index=0&id=1db5f501&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db5f501",
  null
  
)

export default component.exports